// TODO: this file needs some love
// how this value is provided has gone through several iterations,
// and there's almost certainly some redundant/dead/etc code.

export const environment =
  (import.meta.env.VITE_APP_RUN_LOCAL === 'true' && 'local') ||
  window?.CONFIG?.ENVIRONMENT ||
  'dev'

const extension = ['dev', 'qa'].includes(environment) ? 'in' : 'com'

const environmentString = environment === 'prod' ? '' : `${environment}.`

//environment to hit if no local url specified for necessary application
//NOTE: this fallback might be a bad idea since logins/auth will no pervade local/dev
const localDefaultFallback = 'dev'

export const serverUrl =
  window?.CONFIG?.SERVER_URL ??
  `https://api.${environmentString}flowhub.${extension}`

//this function is set up so that we can multiplex localhost services and run the frontend locally against them
//in order for this to work, all services that require connection must have an corresponding environment variable set
//a fallback is configured but this might be awkward since auth will not will across envs unless you copy paste your token
export const getServiceUrl = (service) => {
  if (environment === 'local') {
    //each local service must have a corresponding `VITE_APP_{service}_URL` environment var defined
    //to do this, run the maui backend with desired port set with export PORT={port}, then "make run-{service}"
    //set the VITE_APP_{service}_URL to localhost:{port} (or corresponding docker if running in docker)
    let localDefaultServiceurl = `https://api.${localDefaultFallback}.flowhub.${
      ['dev', 'qa'].includes(localDefaultFallback) ? 'in' : 'com'
    }`
    // Trailing slashes would otherwise double up ("https://host//graph"), and
    // stripping them is what turns the "/" sentinel below into a bare "".
    const configured = `${import.meta.env[`VITE_APP_${service}_URL`]}`.replace(
      /\/+$/,
      ''
    )

    let url =
      `${configured}/${service}` || `${localDefaultServiceurl}/${service}`

    // "/" means "same origin as the page": the resulting '/graph' is served by
    // whatever host the app was loaded from, which is how the app talks to
    // graph through the Vite dev proxy — including when that host is a public
    // tunnel. Leave the leading slash alone.
    if (url.startsWith('/')) {
      return url
    }

    // Otherwise the value may be a bare host ("localhost:8080") or already
    // carry a scheme — an https tunnel URL (ngrok et al) when the local stack
    // is exposed publicly. Only prepend http:// when there is no scheme at
    // all; a substring check for 'http://' does not see 'https://' and would
    // build 'http://https://…'.
    if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(url)) {
      url = `http://${url}`
    }
    return url
  }
  return `${serverUrl}/${service}`
}

// agentapi (the in-monorepo agent platform) hosts both the GraphQL endpoint
// (`<base>/agentapi/query`) and the OAuth token-exchange endpoint
// (`<base>/agentapi/oauth/token`) on the same service. We expose the *host base*
// (no trailing path) so the agent client can derive both endpoints.
//
// Local dev: agentapi runs on http://localhost:8100 (PORT_agentapi in the
// backend Makefile). Set VITE_APP_agentapi_URL to override, or rely on this.
const AGENTAPI_LOCAL_DEFAULT = 'http://localhost:8100'

export const getAgentApiBaseUrl = (): string => {
  if (environment === 'local') {
    const configured = import.meta.env.VITE_APP_agentapi_URL as
      | string
      | undefined
    if (!configured) return AGENTAPI_LOCAL_DEFAULT
    return configured.includes('http') ? configured : `http://${configured}`
  }
  // Non-local: agentapi is reachable behind the shared API gateway alongside
  // the other services, so the host base is simply `serverUrl`.
  return serverUrl
}

// GraphQL endpoint used for ensureAgentSession / sendMessage / agentProgress.
export const getAgentApiGraphqlUrl = (): string =>
  `${getAgentApiBaseUrl()}/agentapi/query`

// OAuth token-exchange endpoint (RFC 8693 token-exchange grant). lib/oauth mounts
// these routes both bare and under the service name; the service-prefixed form is
// the one the gateway routes in deployed environments, and it also serves locally.
export const getAgentApiTokenUrl = (): string =>
  `${getAgentApiBaseUrl()}/agentapi/oauth/token`
